<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    官田站<br>
站点介绍<br>
官田站位于北环路，毗邻宝石东路，沿北环路路中呈东西向敷设。车站两端头位置处的路面高差约为0.5m。站点周边用地主要以工业用地和居住用地为主，周边建筑多为3、4层的多层建筑。其中北侧有既有的深圳市石岩广通汽车修配厂，南侧崇基五金塑胶(深圳）有限公司，规划中将进行旧改、拆迁。道路与南北两侧物业地块为斜坡式连接。北环路现状宽为40米，双向4车道。车站位置路中设2m宽绿化带。规划紧邻车站以工业和居住用地为住，站点外围以居住和工业用地为住，商业用地主要位于道路南侧。规划北环道路红线为40米，车站沿路中布置，以满足车站结构、地面二层以上设备区紧急疏散及部份设备设置的要求。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:10	23:37	6号线	3分24秒	6分20秒<br>
松岗	06:13	23:33	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:18	23:37	6号线	4分45秒	6分钟<br>
松岗	06:19	23:33	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:18	00:37	6号线	4分45秒	6分钟<br>
松岗	06:19	00:33	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
B出入口:<br>
北环路北侧（东）、石观路<br><br>
C出入口:<br>
北环路南侧（西）、月明街、崇基工业园二区<br><br>
D出入口:<br>
北环路南侧（东）宝石东路、崇基工业园一区<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 官田地铁站<br>
316 , 791，M379 ,M551， D出入口<br><br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>